import React from "react";
import OurPromise from "./ourPromise"
import Leadership from "./leadership"
import Partnership from "./partnership"
import GlobalSpread from "./globalSpread"
import CaseStudies from "./caseStudies"

const About = () => {
  return (
    <div>
      <OurPromise />
      <Leadership />
      <Partnership />
      <GlobalSpread />
      <CaseStudies />
    </div>
  );
};

export default About;
